/*
 * Press row (blocks/sis-press-row.liquid): below 990px the logos run as an
 * endless strip, but only when they don't fit. This adds .is-running to the
 * row's viewport while its first list (the copy hidden) is wider than the
 * viewport, and re-checks on resize. Desktop never runs (the CSS animation
 * lives in the max-width: 989px query).
 */
const fit = (viewport) => {
  const list = viewport.querySelector('.sis-press-row__logos');
  if (!list) return;
  viewport.classList.remove('is-running');
  viewport.classList.toggle('is-running', list.scrollWidth > viewport.clientWidth + 1);
};

const resizer = new ResizeObserver((entries) => entries.forEach((e) => fit(e.target)));
const watch = (root) =>
  root.querySelectorAll('.sis-press-row__viewport').forEach((viewport) => {
    if (viewport.dataset.sisWatched) return;
    viewport.dataset.sisWatched = '1';
    resizer.observe(viewport);
    fit(viewport);
  });

watch(document);
document.addEventListener('shopify:section:load', (e) => watch(e.target));
